<app-banner [loading]="loading" [info]="true" [heading]="heading" [subHeading]="subHeading">


  <div class="toolbar-content">

    <button class="btn btn-back" (click)="exit()">
      <i class="fa fa-arrow-left"></i>
      <span>dashboard</span>
    </button>

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }

    <button (click)="toggleSearch()" aria-label="Search for requests by registration number" class="btn">
      <i class="fa fa-search"></i>
      <span>search</span>
    </button>

  </div>

</app-banner>

<app-collapsible [trigger]="searchVisible ">
  <div class="content no-boxes form-inline search-bar">

    <div class="form-group reg-number">
      <input #regNumberInput placeholder="Registration number..." [(ngModel)]="regNumber" (keyup.enter)="search(regNumberInput.value)"
        type="text" name="regNumber" class="form-control " />
        @if (isNIR) {
          <app-utc-date-picker [readonly]="readonly" [(ngModel)]="searchCriteria.date" (ngModelChange)="filterByNirIssuedDate($event)" [placeholder]="'choose date'"></app-utc-date-picker>
        }
        <button class="btn btn-primary ml-2" [disabled]="!regNumber" (click)="search(regNumberInput.value)" >Search</button>
        <button class="btn btn-default ml-2" (click)="clearSearch()">Clear</button>
      </div>
      <div class="statuses">
        @if (isNIR || isNOR) {
          <span class="status " (click)="filterManuallyEdited()" [class.manual-toggle]="manuallyEdited">Manually edited</span>
        }
        @if (isNIR) {
          <span class="status " (click)="filterBySupplimentaryNirIssued(true)" [class.manual-toggle]="hasIssuedSupplimentaryNir">Supplimentary NIR issued</span>
        }
        @if (isNIR) {
          <span class="status " (click)="filterBySupplimentaryNirNotIssued(false)" [class.manual-toggle]="suppNirNotIssued">Supplimentary NIR NOT issued</span>
        }
        @if (isNOR) {
          <span class="status " (click)="filterNorIssued()" [class.norIssued-toggle]="norIssued">NorIssued</span>
        }
      </div>
    </div>
  </app-collapsible>


  @if (items?.length) {
    <div class="content no-boxes page-container">
      <ng-container *ngTemplateOutlet="pager"></ng-container>
    </div>
  }
  @if (items?.length) {
    <div class="content no-boxes fadein" style="padding:0">
      <table class="table">
        <thead>
          <tr>
            <th>
            </th>
            <th style="width: 200px">Registrant</th>
            <th >Registration Status</th>
            <th>Renewal date</th>
            <th>{{revalidationStatusString}} deadline</th>
            @if (isNOR) {
              <th>Nor issued date</th>
            }
            <th>{{revalidationStatusString}} status</th>
            <th>Exception Request o/s</th>
            <th>Essential emails / texts</th>
            <th>Full submission</th>
            <th>Dual Registrant</th>
            <th>Review Status</th>
            <th>Under investigation</th>
            <th>Reval exempt</th>
            @if (isNIR) {
              <th> Supplimentary NIR issued</th>
            }
            @if (isNIR) {
              <th> Supplimentary NIR deadline</th>
            }
            @if (isNIR || isNOR) {
              <th></th>
            }
            @if (isNIR) {
              <th></th>
            }
            @if (isNOR) {
              <th></th>
            }
            <!-- <th *ngIf="isNIR"> Supplimentary NIr issued</th>
            <th *ngIf="isNIR"> Supplimentary NIr deadline</th> -->
          </tr>
        </thead>
        <tbody>
          @for (item of items; track item) {
            <tr [class.manual]="item.manual" [class.moving]="item === moving">
              <td>
                @if (item.manual) {
                  <i class="fa fa-hand-paper-o manual-icon" aria-hidden="true"  [appTooltip]="manualTooltip"></i>
                }
              </td>
              <td>{{item.registrationNumber}} - {{ item.registeredName }} </td>
              <td>{{ RegistationStatus[item.registrationStatus]}}</td>
              <td>{{ item.renewalDate | utcDate }}</td>
              @if (isNOR) {
                <td> {{ item.noREndDate | utcDate: 'd/MM/yyyy'}} </td>
              }
              @if (isNOR) {
                <td> {{ item.noRLetterIssuedDate | utcDate: 'd/MM/yyyy'}}</td>
              }
              @if (isNIR) {
                <td> {{ item.noIREndDate | utcDate: 'd/MM/yyyy' }}</td>
              }
              @if (isNOR) {
                <td> {{ RemediationStage[item.noRStage]  }}</td>
              }
              @if (isNIR) {
                <td> {{ RemediationStage[item.noIRStage] }}</td>
              }
              @if (isRemediation) {
                <td>{{ item.remediationEndDate | utcDate: 'd/MM/yyyy' }}</td>
              }
              @if (isRemediation) {
                <td>{{ RemediationStage[item.remediationStage] }}</td>
              }
              <td> {{ item.hasOutstandingExceptionalCircumstance | friendlyBoolean }} </td>
              <td> {{ item.receivesEssentailEmails | friendlyBoolean }} / {{ item.receivesEssentailTexts | friendlyBoolean }}
              </td>
              <td> {{ item.fullSubmissionReceivedForCurrentStage | friendlyBoolean }} </td>
              <td> {{ item.alsoPharmacist | friendlyBoolean }} </td>
              <td> {{ ReviewStage[item.reviewStage] | caseSplit }} </td>
              <td> {{ item.underInvestigation | friendlyBoolean }}</td>
              <td> {{ item.exemptFromRevalidationSubmissions | friendlyBoolean }}</td>
              @if (isNIR) {
                <td>
                  {{ item.wasNoIRSupplementaryIssued | friendlyBoolean}}
                </td>
              }
              @if (isNIR) {
                <td>
                  {{ item.noIRSupplementaryDeadline | utcDate}}
                </td>
              }
              @if (isNOR) {
                <td class="button-column">
                  <!-- Move to NIR -->
                  @if (moving !== item) {
                    <button (click)="moveToNoir(item)" class="btn btn-primary" [appTooltip]="toNoirTooltip" >
                      <i class="fa fa-arrow-right" aria-hidden="true"></i> NIR
                    </button>
                  }
                  @if (moving === item) {
                    <i class="fa fa-circle-o-notch fa-spin moving  fa-3x"></i>
                  }
                </td>
              }
              @if (isNOR) {
                <td>
                  <!-- IssueNorLetter -->
                  @if (moving !== item) {
                    <div>
                      <button (click)="issueNorLetter(item)" class="btn btn-primary" [appTooltip]="issueNorLetterTooltip"
                        [disabled]="issuingNorLetter === item || item.noRStage === RemediationStage.NoRIssued">
                        @if (issuingNorLetter === item) {
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        }
                        @if (issuingNorLetter !== item) {
                          <i class="fa fa-envelope" aria-hidden="true"></i>
                          } NOR
                        </button>
                        <div style="font-size:0.8em;text-align:center">{{ item.noRLetterIssuedDate | utcDate: 'd/MM/yyyy' }}</div>
                      </div>
                    }
                  </td>
                }
                @if (isNIR) {
                  <td>
                    <!-- Move to NOR -->
                    @if (moving !== item) {
                      <button (click)="moveToNor(item)" [disabled]="moving === item" class="btn btn-primary"
                        [appTooltip]="toNorTooltip">
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        NOR
                      </button>
                    }
                    @if (moving === item) {
                      <i class="fa fa-circle-o-notch fa-3x fa-spin moving"></i>
                    }
                  </td>
                }
                @if (isNIR) {
                  <td>
                    @if (moving !== item) {
                      <div>
                        <button (click)="issueSupplementaryNir(item)" [disabled]="issuingSupplementaryNir === item" class="btn btn-primary"
                          [appTooltip]="supplementaryNIRTooltip">
                          <i class="fa fa-hourglass-1" [class.fa-spin]="issuingSupplementaryNir === item"></i> NIR
                        </button>
                        <div style="font-size:0.8em;text-align:center">{{ item.noIRSupplementaryIssuedAt | utcDate: 'd/MM/yyyy' }}</div>
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="content no-boxes fadein">
        @if (!loading) {
          <div class="no-data">
            There are currently no registrants in {{revalidationStatusString}}. Please check other dashboards.
          </div>
        }
      </div>
    }

    <ng-template #pager>
      <div class="pager">

        <button [disabled]="pageNum === 0" (click)="prevPage()">
          <i class="fa fa-chevron-left"></i>
        </button>

        <button [disabled]="(pageNum + 1) * pageSize >= totalCount" (click)="nextPage()">
          <i class="fa fa-chevron-right"></i>
        </button>

        <span class="info">{{ pageFrom }} - {{ pageTo }} of {{totalCount}}</span>

      </div>
    </ng-template>
